//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "BirthdayScreen",

  emits: ['closeScreenBirthday'],

  methods: {
    closeScreenBirthday() {
      this.$emit('closeScreenBirthday');
    },
  },
}
